module.exports = __webpack_public_path__ + "assets/img/23_129_big.ebc02e41.jpg";